(function() {
  'use strict';

  angular.module('cfn').directive('dTabContainer', function() {
    return {
      restrict: 'E',
      transclude: true,
      scope: {
        activeIndex: '='
      },
      templateUrl: require('./d-tab-container.html'),
      controller: [
        '$scope',
        function($scope) {
          var ctrl = this;
          ctrl.scope = $scope;

          ctrl.setActiveIndex = function(index) {
            $scope.activeIndex = index;
          };

          ctrl.getActiveIndex = function() {
            return $scope.activeIndex;
          };
        }
      ]
    };
  });
})();
